import { render, staticRenderFns } from "./UserBillBalanceLogs.vue?vue&type=template&id=9d96d800&"
import script from "./UserBillBalanceLogs.vue?vue&type=script&lang=js&"
export * from "./UserBillBalanceLogs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports